// extracted by mini-css-extract-plugin
module.exports = {"ThankYou":"ThankYou_ThankYou__2wmvJ","header":"ThankYou_header__2q1ad","warning":"ThankYou_warning__3807Z"};